// extracted by mini-css-extract-plugin
module.exports = {"component":"ClubLocation_component__1Jc7O","location":"ClubLocation_location__rawRw","map":"ClubLocation_map__3uytF","editHolder":"ClubLocation_editHolder__1mh5F"};